import React, { Component } from 'react';
import { Button, Form, Input, message, Icon, Col, Row } from 'antd';
import loginbg from '../../style/imgs/loginbg.jpg';
import indexLogo from '../../style/imgs/index_logo.png';
import { postFrom, post, config } from "../../axios";

const FormItem = Form.Item;
class Login extends Component {
    state = {
        loading: false,
        disabled: false, //禁用发送验证码
        countDown: false, //显示倒计时
        second: 60,
    }

    

    componentWillUnmount() {
        clearInterval(this.timer)
    }

    sendViy = () => {
        let phone = this.props.form.getFieldValue('phone');
        if (phone) {
            this.setState({ disabled: true });
            postFrom({ url: config.API_open_home_sendVerifyCode, data: { phone } }).then(res => {
                message.success('发送成功');
                this.setState({ countDown: true }); // 打开倒计时
                this.timer = setInterval(() => {
                    let second = this.state.second - 1;
                    if (second === 0) {
                        clearInterval(this.timer)
                        this.setState({ disabled: false, second: 60, countDown: false });
                    } else {
                        this.setState({ second });
                    }
                }, 1000);
            }).catch(err => {
                message.error(err.message || '发送失败');
                this.setState({ disabled: false });
            });
        } else {
            message.error('请填写手机号')
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { history } = this.props;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true });
                if (values.password === values.password2) {
                    delete values.password2;
                    post({ url: config.API_open_home_resetPasswordMerchantUser, data: values }).then(res => {
                        message.success('修改成功');
                        this.setState({ loading: false });
                        history.push({ pathname: '/merchantLogin' });
                    }).catch(err => {
                        message.error(err.message || '修改失败');
                        this.setState({ loading: false });
                    });
                } else {
                    message.error('两次密码输入不一致');
                    this.setState({ loading: false });
                }
            }
        });
    };

    render() {
        let { getFieldDecorator } = this.props.form;
        let { loading, disabled, second, countDown } = this.state;

        return (
            <div>
                <div style={{textAlign:'center'}}>
                    <img src={indexLogo} width="200" alt="" />
                </div>
                <div className="login">
                    <div className="login-form" >
                        <div className="login-logo">
                            <span>找回密码</span>
                        </div>
                        <Form onSubmit={this.handleSubmit}>
                            <FormItem>
                                {getFieldDecorator('phone', {
                                    rules: [{ required: true, message: '请输入' }],
                                })(
                                    <Input autoComplete={'off'} prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder="请输入手机号" />
                                )}
                            </FormItem>
                            <Row>
                                <Col span={15}>
                                    <FormItem>
                                        {getFieldDecorator('verifyCode', {
                                            rules: [{ required: true, message: '请输入' }],
                                        })(
                                            <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} placeholder="请输入验证码" />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={8} offset={1} style={{ textAlign: 'center', lineHeight: '44px' }}>
                                    {
                                        countDown
                                            ? <span>{second}s后重新发送</span>
                                            : <Button style={{ height: '44px', lineHeight: '40px' }} disabled={disabled} onClick={this.sendViy}>获取验证码</Button>
                                    }
                                </Col>
                            </Row>
                            <FormItem>
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: '请输入' }],
                                })(
                                    <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="输入新密码" />
                                )}
                            </FormItem>
                            <FormItem>
                                {getFieldDecorator('password2', {
                                    rules: [{ required: true, message: '请输入' }],
                                })(
                                    <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="再次新输入密码" />
                                )}
                            </FormItem>
                            <FormItem>
                                <Button loading={loading} type="primary" htmlType="submit" className="login-form-button" style={{ width: '100%', marginTop: '10px' }}>确定</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <style>{`
                    .login {
                        background-image: url(${loginbg});
                    }
                `}</style>
                </div>
                <div style={{ marginTop: '65px', textAlign: 'center', padding: '30px 0', color: '#999', lineHeight: '30px' }}>Copyright © 中和智家（深圳）科技有限公司 ALL Rights Reserved
                    &nbsp;&nbsp;&nbsp;&nbsp;<a
                        href="http://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" className="beian"
                        hotrep="hp.footer.bottom.miitbeian"
                                            >粤ICP备18025237号-1</a></div>
            </div>
        );
    }

   

    
}

export default Login = Form.create()(Login);


// WEBPACK FOOTER //
// ./src/page/pages/MerchantModifyPassword.js